import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { Home, ArrowLeft } from "lucide-react";
import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import TopHeader from "../components/TopHeader";
import Footer from "../components/Footer";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    Sentry.captureMessage(`404: ${location.pathname}`, "warning");
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col">
      <TopHeader />

      <div className="flex-1 flex items-center justify-center px-6 py-24">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.45 }}
          className="text-center max-w-md"
        >
          {/* Big 404 */}
          <div className="relative mb-8 select-none">
            <span className="text-[120px] font-black leading-none bg-gradient-to-br from-primary/20 to-primary/5 bg-clip-text text-transparent">
              404
            </span>
            <span className="absolute inset-0 flex items-center justify-center text-[120px] font-black leading-none text-foreground/5 blur-sm">
              404
            </span>
          </div>

          <h1 className="text-2xl font-bold text-foreground mb-3">
            Page not found
          </h1>
          <p className="text-muted-foreground leading-relaxed mb-10">
            The page at <code className="text-sm font-mono bg-muted px-1.5 py-0.5 rounded text-foreground">{location.pathname}</code> doesn't exist or has moved.
          </p>

          <div className="flex items-center justify-center gap-3 flex-wrap">
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl btn-neu-primary text-sm font-semibold transition-all"
            >
              <Home className="w-4 h-4" />
              Go home
            </Link>
            <button
              type="button"
              onClick={() => window.history.back()}
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl border border-border bg-background hover:bg-accent text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
            >
              <ArrowLeft className="w-4 h-4" />
              Go back
            </button>
          </div>
        </motion.div>
      </div>

      <Footer />
    </div>
  );
};

export default NotFound;
